import { useParamsSearch } from '@anytag/shared-hooks';
import { PackagesSearchSchemaType } from '../schemaTypes';

export const usePackagesFilter = () => useParamsSearch<PackagesSearchSchemaType>();
